module.exports = __webpack_public_path__ + "static/0034-72338c45c5395a1cad53f26b5b5c9850.png";